export function getExistingFilterData(fieldId, filters) {
  const existingFilter = filters
    ? filters.find(filter => filter.field === fieldId)
    : undefined;
  return existingFilter &&
    existingFilter.values &&
    existingFilter.values.length > 0
    ? existingFilter.values
    : undefined;
}

export function getExistingFilterDataFirstValue(fieldId, filters) {
  const existingFilterData = getExistingFilterData(fieldId, filters);
  return existingFilterData ? existingFilterData[0] : undefined;
}

export function getFacetForId(facets, facetId) {
  if (!facets || !facetId) {
    return undefined;
  }

  return facets[facetId];
}

export function stringOrDefault(data, defaultVal) {
  return data || defaultVal;
}

export function arrayToStringOrDefault(data, defaultVal) {
  return Array.isArray(data) && data.length > 0 ? data.join(', ') : defaultVal;
}
